import DataExtractionFieldHeader, {
  __typename as headerTypename,
} from './DataExtractionFieldHeader';
import DataExtractionFieldText, {
  __typename as textTypename,
} from './DataExtractionFieldText';
import DataExtractionFieldSingleSelect, {
  __typename as singleSelectTypename,
} from './DataExtractionFieldSingleSelect';
import DataExtractionFieldMultipleSelect, {
  __typename as multiSelectTypename,
} from './DataExtractionFieldMultipleSelect';

import { DataExtractionFieldInputType } from '@/enums';

const typenameToClassProtoMap = {
  [headerTypename]: DataExtractionFieldHeader,
  [textTypename]: DataExtractionFieldText,
  [singleSelectTypename]: DataExtractionFieldSingleSelect,
  [multiSelectTypename]: DataExtractionFieldMultipleSelect,
};

const typenameToGraphqlTypeEnum = {
  [headerTypename]: DataExtractionFieldInputType.HEADER,
  [textTypename]: DataExtractionFieldInputType.TEXT,
  [singleSelectTypename]: DataExtractionFieldInputType.SINGLE_SELECT,
  [multiSelectTypename]: DataExtractionFieldInputType.MULTIPLE_SELECT,
};

export function createDataExtractionField(data) {
  if (!data.__typename) {
    throw new Error('__typename field required to convert data');
  }
  const classProto = typenameToClassProtoMap[data.__typename];
  if (!classProto) {
    throw new Error(
      `__typename "${data.__typename}" has not been registered`
    );
  }
  return new classProto(data);
}

export function createDataExtractionFieldInput(field) {
  return {
    type: typenameToGraphqlTypeEnum[field.__typename],
    title: field.title,
    description: field.description,
    required: field.required,

    multipleChoiceOptions: field.multipleChoiceOptions,
    otherOption: field.otherOption,
  };
}
